export default {"src":"/_next/static/image/public/assets/icons/thumb-up.04b499b40c27df46fb4f4b3778ec48a0.svg","height":24,"width":24};